import type { ICard } from "../../api/cardsSlice";
import type {
  ReadingContext,
  ReadingSection,
  ReadingSectionDefinition,
  ReadingSectionSource,
} from "./types";

type ResolvedValue = string | string[] | undefined;

const cleanValue = (value: ResolvedValue): ResolvedValue => {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed === "" ? undefined : trimmed;
  }

  if (Array.isArray(value)) {
    const items = value.map((item) => item.trim()).filter(Boolean);
    return items.length > 0 ? items : undefined;
  }

  return undefined;
};

const resolveSource = (
  card: ICard,
  source: ReadingSectionSource,
  context: ReadingContext
): ResolvedValue => {
  switch (source.type) {
    case "keywords":
      return card.keywords;

    case "psychology":
      return card.psychology;

    case "archetype":
      return card.archetype;

    case "readingTips":
      return card.readingTips;

    case "selfQuestions":
      return card.selfQuestions;

    case "upright":
      return card.upright[source.context];

    case "uprightByQuestionContext":
      if (context.topic === "general") {
        return undefined;
      }

      return card.upright[context.topic];
  }
};

export const resolveCardSections = (
  card: ICard,
  definitions: ReadingSectionDefinition[],
  context: ReadingContext
): ReadingSection[] =>
  definitions.flatMap((definition) => {
    const value = cleanValue(
      resolveSource(card, definition.source, context)
    );

    if (value === undefined) {
      return [];
    }

    return [
      {
        id: definition.id,
        title: definition.title,
        value,
      },
    ];
  });


